import { ForgotPasswordScreen } from "@/features/auth/screens/ForgotPasswordScreen";
import { forgotPasswordRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import { createFileRoute } from "@tanstack/react-router";

const ForgotPasswordPage = () => {
    const { email, phone, method } = Route.useSearch();
    return <ForgotPasswordScreen email={email} phone={phone} method={method} />;
};

export const Route = createFileRoute("/_auth/forgot-password/")({
    component: ForgotPasswordPage,
    validateSearch: (search) => forgotPasswordRouteSearchSchema.parse(search),
});
